import { render } from "./PatientRegistration.vue?vue&type=template&id=d22ab458&ts=true"
import script from "./PatientRegistration.vue?vue&type=script&lang=ts"
export * from "./PatientRegistration.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/armieisla/workspace/charmedteq/icare/icare-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__